import React, { useMemo, useState } from "react";
import { Button, Table } from "antd";
import dayjs from "dayjs";
import DeleteModal from "./DeleteModal";
import { emailReport } from "../../services/reports";
import toast from "react-hot-toast";


const ProfileTable = ({ pdfs, loading, pagination, setUpdate,handleTableChange }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState();
  const [emailLoading,setEmailLoading]=useState(false);

  const deleteModal = (id) => {
    setId(id);
    setOpen(true);
  };

  const handleEmailReport=async(id)=>{
    try {
        setEmailLoading(true);

    const response=await emailReport(id);

    if(response?.success){
      toast.success(response.message); 
    } else {
      toast.error(response?.message || "Failed to send report.");
    }
        
    } catch (error) {
      console.log(error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to send report email.";
      toast.error(apiMessage);
    } finally {
      setEmailLoading(false);
    }
  

  }

  

  const columns = useMemo(() => [
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => dayjs(text).format("DD MMM YYYY, hh:mm A"),
      width: "30%",
    },
    {
      title: "Sent on",
      dataIndex: "email",
      width: "30%",
    },
    {
      title: "Actions",
      key: "actions",
      width: "40%",
      render: (_, record) => (
        <div className="flex justify-center items-center gap-x-2">
          <Button type="primary" loading={emailLoading} onClick={() => handleEmailReport(record._id)}>
            Email PDF
          </Button>
          <Button type="primary" onClick={() => deleteModal(record._id)} danger>
            Delete
          </Button>
        </div>
      ),
    },
  ]);

 


  return (
    <>
      
      <DeleteModal open={open} setOpen={setOpen} id={id} setUpdate={setUpdate}  />
      <Table
        columns={columns}
        dataSource={pdfs}
        onChange={handleTableChange}
        loading={loading}
        rowKey="_id"
        pagination={pagination}
      />
    </>
  );
};

export default ProfileTable;
